import gql from "graphql-tag";

const CONTACT_FIELDS = gql`
  fragment ContactFields on Contacts {
    id
    installationId
    type
    name
    description
    email
    phone
    smsTemplate
  }
`;

export const contactQuery = gql`
  query Contact($id: ID!) {
    contact(id: $id) {
      ...ContactFields
    }
  }
  ${CONTACT_FIELDS}
`;

export const featureByNameQuery = gql`
  query GetFeatureByName($name: String!) {
    getFeatureByName(name: $name) {
      id
      name
      baseConfiguration
    }
  }
`;

export const contactsQuery = gql`
  query Contacts($installationId: ID!) {
    contacts(installationId: $installationId) {
      ...ContactFields
    }
  }
  ${CONTACT_FIELDS}
`;

export const bookingContactsQuery = gql`
  query BookingContacts($installationId: ID!) {
    contacts(installationId: $installationId, type: BOOKING) {
      ...ContactFields
    }
  }
  ${CONTACT_FIELDS}
`;

export const createContactMutation = gql`
  mutation CreateContact($contact: ContactCreateInput!) {
    createContact(contact: $contact) {
      ...ContactFields
    }
  }
  ${CONTACT_FIELDS}
`;

export const updateContactMutation = gql`
  mutation UpdateContact($contact: ContactUpdateInput!) {
    updateContact(contact: $contact) {
      ...ContactFields
    }
  }
  ${CONTACT_FIELDS}
`;

export const deleteContactMutation = gql`
  mutation DeleteContact($id: ID!) {
    deleteContact(id: $id)
  }
`;
